import { render, staticRenderFns } from "./GlobalEnvelopIcon.vue?vue&type=template&id=5c4bcd29"
import script from "./GlobalEnvelopIcon.vue?vue&type=script&lang=js"
export * from "./GlobalEnvelopIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports